import Styled from 'styled-components';

import { ICheckboxContain } from './common';
import { CheckboxInputStyles } from './CheckboxInputStyles';
import { CheckboxLabel } from './CheckboxLabel';

// tslint:disable-next-line:max-line-length
const iconChecked: string = `"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='16px' height='14px' viewBox='0 0 16 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EShape%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='check-simple' fill='%23FFFFFF' fill-rule='nonzero'%3E%3Cpolygon id='Shape' points='5.6 8.6 2.4 5.4 0 7.8 5.6 13.4 16 3 13.6 0.6'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/svg%3E"`;

export const CheckboxInput = Styled.input<ICheckboxContain>`
  ${CheckboxInputStyles}

  /* stylelint-disable */
  &:hover + ${CheckboxLabel}::before,
  &:focus + ${CheckboxLabel}::before {
    border: 1px solid ${({ theme: { radio }}) => radio.colorBorder};
  }

  &:checked + ${CheckboxLabel}::before {
    border: 1px solid ${({ theme: { radio }}) => radio.colorBorder};
  }

  &:checked + ${CheckboxLabel}::after {
    background-image: url(${iconChecked});
    background-size: 0.625em;
    background-color: ${({ theme: { checkbox }}) => checkbox.colorBackground};
  }
  /* stylelint-enable */
`;
